import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter);

const routes = [];

const pcRoutes = {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'home',
    meta: {},
    children: [
        // マイページ
        {
            path: 'home',
            component: () => import('@/views/home/home.vue'),
            name: 'home',
            meta: {
                type: 'home',
                title:'マイページ｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'station',
            component: () => import('@/views/home/station.vue'),
            name: 'station',
            meta: {
                type: 'home',
                title:'WEB予約｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'datetime',
            component: () => import('@/views/home/datetime.vue'),
            name: 'datetime',
            meta: {
                type: 'home',
                title:'WEB予約｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'seat',
            component: () => import('@/views/home/seat.vue'),
            name: 'seat',
            meta: {
                type: 'home',
                title:'WEB予約｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'customerInfo',
            component: () => import('@/views/home/customerInfo.vue'),
            name: 'customerInfo',
            meta: {
                type: 'home',
                title:'WEB予約｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'confirm',
            component: () => import('@/views/home/confirm.vue'),
            name: 'confirm',
            meta: {
                type: 'home',
                title:'WEB予約｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'list',
            component: () => import('@/views/home/list.vue'),
            name: 'list',
            meta: {
                type: 'home',
                title:'予約一覧｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'detail',
            component: () => import('@/views/home/detail.vue'),
            name: 'detail',
            meta: {
                type: 'home',
                title:'予約詳細｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'stationChange',
            component: () => import('@/views/home/stationChange.vue'),
            name: 'stationChange',
            meta: {
                type: 'home',
                title:'予約内容の変更｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'changeConfirm',
            component: () => import('@/views/home/changeConfirm.vue'),
            name: 'changeConfirm',
            meta: {
                type: 'home',
                title:'予約内容の変更｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'changeCompleted',
            component: () => import('@/views/home/changeCompleted.vue'),
            name: 'changeCompleted',
            meta: {
                type: 'home',
                title:'予約内容の変更完了｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'cancelSeat',
            component: () => import('@/views/home/cancelSeat.vue'),
            name: 'cancelSeat',
            meta: {
                type: 'home',
                title:'任意の座席をキャンセル｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'cancel',
            component: () => import('@/views/home/cancel.vue'),
            name: 'cancel',
            meta: {
                type: 'home',
                title:'予約のキャンセル｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'ticket',
            component: () => import('@/views/home/ticket.vue'),
            name: 'ticket',
            meta: {
                type: 'home',
                title:'チケット｜小湊鐵道 指定席券'
            }
        },
        {
            path: 'error',
            component: () => import('@/views/home/error.vue'),
            name: 'error',
            meta: {
                type: 'home',
                title:'エラー｜小湊鐵道 指定席券'
            }
        },
    ]
};

let spRoutes = {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'home',
    meta: {
        title:'マイページ｜小湊鐵道 指定席券'
    },
    children: []
};

pcRoutes.children.forEach(item => {
    spRoutes.children.push({
        path: item.path,
        component: (resolve) => require([`@/spviews/${item.meta.type}/${item.name}.vue`], resolve),
        name: item.name,
        meta: {
            type: item.meta.type,
            title:item.meta.title
        }
    })
})
function isSmartPhone() {
    // UserAgentからのスマホ判定
    if (navigator.userAgent.match(/pad|pod|iPod|iPad|iPhone|Android|Android.+Mobile/)) {
        return true;
    } else {
        return false;
    }
}

function isSmartPhone2() {
    // デバイス幅が640px以下の場合にスマホと判定する
    if (
        window.matchMedia &&
        window.matchMedia("(max-device-width: 640px)").matches
    ) {
        return true;
    } else {
        return false;
    }
}

const createRouter = () => new VueRouter({
    mode: 'history',
    base: '/reserve/kominato/',
    scrollBehavior: () => ({
        y: 0
    }),
    isAddDynamicMenuRoutes: false, // ダイナミック（メニュー）ルーティングが追加されているかどうか
    routes: routes
})

const router = createRouter();

export default router;

router.beforeEach((to, from, next) => {
    if (router.options.isAddDynamicMenuRoutes) {
        router.options.isAddDynamicMenuRoutes = true;
        next();
    } else {
        // console.log(to.query)
        // console.log(to.query.debugMode)
        if (to.query.debugMode) {
            if (to.query.debugMode == "p") {
                router.addRoute(pcRoutes);
            } else if (to.query.debugMode == "s") {
                router.addRoute(spRoutes);
            }
        } else {
            if(isSmartPhone() || isSmartPhone2()){
                router.addRoute(spRoutes);
            }else {
                router.addRoute(pcRoutes);
            }
        }
         // 存在しないパスを入力するとマイページにリダイレクトする
         router.addRoute({
            path: '*',
            redirect: '/',
        })
        router.options.isAddDynamicMenuRoutes = true;
        next({
            ...to,
            replace: true
        });
    }
})
